import { Helmet } from 'react-helmet'
import { getStepNumber } from 'config/onboarding'
import { getTitle } from 'config/titles'
import Onboarding from 'components/Onboarding'
import { useNetwork } from '~/networkProvider'
import { FacilityScreenContainer } from '~/components/FacilityScreenContainer'

const OnboardingObstructionsScreen = () => {
  const { online } = useNetwork()
  return (
    <FacilityScreenContainer>
      <Helmet>
        <title>{getTitle('obstructions')}</title>
      </Helmet>
      <Onboarding online={online} step={getStepNumber('Obstructions')} message="Add obstructions to your facility." />
    </FacilityScreenContainer>
  )
}

export default OnboardingObstructionsScreen
